import { useState } from "react";

export default function useBuildingBook()
{
    const [hotspot, setHotspot] =
        useState(
        {
            id: 1,
            code: "HS-001",
            name: "Electrical Cupboard",
            floorId: 1,
            floorName: "Level 2",
            description: "Main electrical cupboard serving west wing."
        });

    const [assetCategories, setAssetCategories] =
        useState(
        [
            "HVAC",
            "Electrical",
            "Mechanical",
            "Fire",
            "Security",
            "IT",
            "Furniture"
        ]);

    const [allAssets, setAllAssets] =
        useState(
        [
            {
                id: 1,
                code: "AHU-001",
                name: "Air Handling Unit",
                category: "HVAC"
            },

            {
                id: 2,
                code: "DB-102",
                name: "Distribution Board",
                category: "Electrical"
            },

            {
                id: 3,
                code: "UPS-001",
                name: "UPS System",
                category: "Electrical"
            },

            {
                id: 4,
                code: "FCU-201",
                name: "Fan Coil Unit",
                category: "HVAC"
            },

            {
                id: 5,
                code: "PUMP-001",
                name: "Heating Pump",
                category: "Mechanical"
            },

            {
                id: 6,
                code: "FIRE-001",
                name: "Fire Panel",
                category: "Fire"
            },

            {
                id: 7,
                code: "CCTV-001",
                name: "CCTV Recorder",
                category: "Security"
            }
        ]);

    const [assets, setAssets] =
        useState(
        [
            {
                id: 1,

                code: "AHU-001",

                name: "Air Handling Unit",

                category: "HVAC",

                status: "Operational",

                manufacturer: "Daikin",

                model: "DX200",

                serialNumber: "SN-123456",

                installDate: "2022-04-12",

                lastSurveyDate: "2026-06-01",

                conditionRating: 4,

                conditionText: "Good",

                criticality: "High",

                replacementCost: 25000,

                expectedLifeYears: 20,

                remainingLifeYears: 12,

                description:
                    "Main air handling unit serving west wing.",

                photos:
                [
                    {
                        id: 1,
                        fileName: "ahu-front.jpg",
                        url: "/images/demo/photo1.jpg"
                    },

                    {
                        id: 2,
                        fileName: "ahu-side.jpg",
                        url: "/images/demo/photo2.jpg"
                    }
                ],

                documents:
                [
                    {
                        id: 1,
                        name: "O&M Manual.pdf",
                        type: "Manual"
                    },

                    {
                        id: 2,
                        name: "Warranty.pdf",
                        type: "Warranty"
                    }
                ],

                compliance:
                [
                    {
                        id: 1,
                        name: "PAT Testing",
                        status: "Current",
                        dueDate: "2027-01-01"
                    },

                    {
                        id: 2,
                        name: "Fire Inspection",
                        status: "Due",
                        dueDate: "2026-07-01"
                    },

                    {
                        id: 3,
                        name: "Fixed Wiring",
                        status: "Current",
                        dueDate: "2028-01-01"
                    }
                ],

                history:
                [
                    {
                        id: 1,
                        date: "2026-01-15",
                        event: "Condition Survey"
                    },

                    {
                        id: 2,
                        date: "2025-09-01",
                        event: "Document Uploaded"
                    }
                ]
            },

            {
                id: 2,

                code: "DB-102",

                name: "Distribution Board",

                category: "Electrical",

                status: "Operational",

                manufacturer: "Schneider",

                model: "Acti9",

                serialNumber: "DB-789",

                installDate: "2021-03-01",

                lastSurveyDate: "2026-05-10",

                conditionRating: 3,

                conditionText: "Fair",

                criticality: "Medium",

                replacementCost: 5000,

                expectedLifeYears: 25,

                remainingLifeYears: 10,

                description:
                    "Distribution board serving office lighting.",

                photos: [],

                documents: [],

                compliance:
                [
                    {
                        id: 1,
                        name: "Fixed Wiring",
                        status: "Due",
                        dueDate: "2026-08-01"
                    }
                ],

                history: []
            },

            {
                id: 3,

                code: "UPS-001",

                name: "UPS System",

                category: "Electrical",

                status: "Operational",

                manufacturer: "APC",

                model: "Smart UPS",

                serialNumber: "UPS-555",

                installDate: "2020-07-01",

                lastSurveyDate: "2026-03-10",

                conditionRating: 5,

                conditionText: "Excellent",

                criticality: "Critical",

                replacementCost: 15000,

                expectedLifeYears: 15,

                remainingLifeYears: 7,

                description:
                    "Main UPS protecting network infrastructure.",

                photos: [],

                documents: [],

                compliance: [],

                history: []
            }
        ]);

    const [selectedAssetId, setSelectedAssetId] =
        useState(1);

    let selectedAsset = null;

    for(let i = 0; i < assets.length; i++)
    {
        if(assets[i].id === selectedAssetId)
        {
            selectedAsset = assets[i];
            break;
        }
    }

    return {

        hotspot,

        assets,

        allAssets,

        assetCategories,

        selectedAsset,

        selectedAssetId,

        setSelectedAssetId,

        setAssets,

        setAllAssets,

        setHotspot
    };
}